import { useMemo } from 'react'
import { FadePresence } from '../../../../components/FadePresence'
import { AddExistingBill } from './AddExistingBill'
import { AddNewBill } from './AddNewBill'
import { LinkAccount } from './LinkAccount'
import { useLinkBillContext } from './LinkBill'
import { SelectBillType } from './SelectBillType'
import { LinkBill } from './types'

export const LinkBillContent = ({
    selectBillHeader,
}: {
    selectBillHeader?: (foundBills: boolean, billCount?: string) => React.ReactNode
}) => {
    const { step } = useLinkBillContext()

    const component = useMemo(() => {
        switch (step) {
            case LinkBill.SelectBillType:
                return <SelectBillType selectBillHeader={selectBillHeader} />
            case LinkBill.AddExistingBill:
                return <AddExistingBill />
            case LinkBill.AddNewBill:
                return <AddNewBill />
            case LinkBill.LinkAccount:
                return <LinkAccount />
        }
    }, [selectBillHeader, step])

    return (
        <FadePresence fullWidth renderKey={step}>
            {component}
        </FadePresence>
    )
}
